import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import CMSClient from "./api/CMS-API";
import { HelmetProvider } from "react-helmet-async";
// import ReactGA from "react-ga4";
import "bulma/css/bulma.min.css";
import "./App.css";
import "./App.scss";
import ScrollToTopOnRouteChange from "./components/ScrollTop";
import Layout from "./Layout";
import Landing from "./pages/Landing";
import Privacy from "./pages/Privacy";
import Support from "./pages/Support";
import Terms from "./pages/Terms";

// const GAKey = process.env.REACT_APP_GA_TRACKINGID;

// ReactGA.initialize(GAKey);

export default function App() {
    const [appLoaded, setAppLoaded] = useState(false);
    const [landingData, setLandingData] = useState({});
    const [footerData, setFooterData] = useState({});
    const [termsData, setTermsData] = useState({});
    const [privacyData, setPrivacyData] = useState({});
    const [contactData, setContactData] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const query = `
            {
                "landingData": *[_type == "landing"][0] {
                    pageHeader,
                    pageSubheader,
                    downloadCallToAction,
                    "heroImageURL": heroImage.asset->url,
                    "heroImageAlt": heroImage.altText,
                    aboutHeader,
                    aboutBody,
                    screenshots[] {
                        "screenshotURL": asset->url,
                        header,
                        caption,
                        altText,
                    },
                    aboutIOSCompatibility,
                    aboutAndroidCompatibility,
                    callToActionHeader,
                    callToActionBody,
                    appleUrl,
                    androidUrl,
                    seoPageTitle,
                    seoPageDescription,
                    seoPageAuthor,
                    seoPageType,
                },
                "footerData": *[_type == "footer"][0] {copyright},
                "termsData": *[_type == "terms"][0]{
                    pageHeader,
                    termsBody,
                    seoPageTitle,
                    seoPageDescription,
                    seoPageAuthor,
                    seoPageType,
                },
                "privacyData": *[_type == "privacy"][0]{
                    pageHeader,
                    privacyBody,
                    seoPageTitle,
                    seoPageDescription,
                    seoPageAuthor,
                    seoPageType,
                },
                "contactData": *[_type == "contact"][0]{
                    pageHeader,
                    seoPageTitle,
                    seoPageDescription,
                    seoPageAuthor,
                    seoPageType,
                },
            }
            `;
            try {
                const result = await CMSClient.fetch(query);
                setLandingData(result.landingData);
                setFooterData(result.footerData);
                setTermsData(result.termsData);
                setPrivacyData(result.privacyData);
                setContactData(result.contactData);
                setTimeout(() => {
                    setAppLoaded(true);
                }, "50");
            } catch (error) {
                console.error("Error fetching data from CMS:", error);
            }
        };

        fetchData();
    }, []);

    return (
        appLoaded && (
            <>
                <HelmetProvider>
                    <ScrollToTopOnRouteChange />
                    <Routes>
                        <Route
                            path="/"
                            element={<Layout footerData={footerData} />}
                        >
                            <Route
                                index
                                element={<Landing landingData={landingData} />}
                            />
                            <Route
                                path="privacy/"
                                element={<Privacy privacyData={privacyData} />}
                            />
                            <Route
                                path="support/"
                                element={<Support contactData={contactData} />}
                            />
                            <Route
                                path="terms/"
                                element={<Terms termsData={termsData} />}
                            />
                        </Route>
                    </Routes>
                </HelmetProvider>
            </>
        )
    );
}
